const dashboardLayoutSettings = {
  searchBox: { open: false },
  leftSidebar: { open: true, secondaryNavOpen: false }
};

export default dashboardLayoutSettings;
